<template class="full-height">
  <div class="coupon-category-app-container" style="position: relative; height: 100%">
    <!-- 產生簽署檔彈窗 -->
    <el-dialog
      :top="dialogTopMargin"
      title="產生簽署檔"
      :visible.sync="dialogVisible"
      @closed="handleGenerateContractDialogClose"
    >
      <el-card v-loading="dialogLoading">
        <el-form :model="generateParams">
          <h3 style="border-bottom: 1px solid #eee; padding-bottom: 12px">
            合約檔名：<a
              :href="generateParams.fileLink"
              target="_blank"
              style="color: #1890ff; font-weight: 400"
              >{{ generateParams.fileName }}
              <i class="el-icon-download"></i>
            </a>
          </h3>
          <el-form-item
            v-show="!generateContracts || generateContracts.length == 0"
            label="簽署檔份數"
            prop="generateCount"
            :rules="[
              {
                required: true,
                message: '請輸入要產生的合約簽署檔份數',
                trigger: 'blur',
              },
            ]"
          >
            <el-select
              v-model="generateParams.generateCount"
              placeholder="請輸入要產生的合約簽署檔份數"
              style="max-width: 90px"
            >
              <el-option v-for="item in 100" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div v-show="generateContracts && generateContracts.length > 0">
          <el-table :data="generateContracts" border size="small" height="200px" stripe>
            <el-table-column align="center" label="項次" width="60">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column property="contractLink" label="簽署檔連結">
              <template slot-scope="scope">
                <a style="color: #20a0ff" :href="scope.row.contractLink" target="_blank">{{
                  scope.row.contractLink
                }}</a>
              </template>
            </el-table-column>
            <el-table-column align="center" label="複製" width="130">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  icon="el-icon-copy-document"
                  circle
                  @click="handleClipboard(scope.row.contractLink, $event)"
                >
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>
      <div slot="footer" class="dialog-footer">
        <el-button
          v-show="!generateContracts || generateContracts.length == 0"
          type="warning"
          :loading="dialogLoading"
          @click="handleGenerateContract"
          style="color: #4b4b4b"
          >產 生</el-button
        >
        <el-button @click="dialogVisible = false">{{
          generateContracts && generateContracts.length > 0 ? '關 閉' : '取 消'
        }}</el-button>
      </div>
    </el-dialog>

    <!-- 合約簽署檔彈窗 -->
    <el-dialog
      :title="`【${detail.title}】合約簽署檔`"
      :visible.sync="dialogDetailVisible"
      width="80%"
    >
      <el-card>
        <el-table
          size="mini"
          ref="detailTable"
          :data="detail.data || []"
          border
          stripe
          style="width: 100%"
          height="400"
        >
          <el-table-column align="center" label="項次" width="60">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="ID" prop="signatureId" width="60">
          </el-table-column>
          <el-table-column align="center" label="填寫者">
            <template slot-scope="scope">
              {{ scope.row.client || '-' }}<br />
              <el-tag type="info" size="mini" v-show="!!scope.row.browserId">{{
                scope.row.browserId
              }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" label="建立時間" prop="buildDate" width="130">
          </el-table-column>
          <el-table-column prop="expiredDate" align="center" label="失效日期" width="130">
            <template slot-scope="scope">
              <el-tag effect="plain" :type="scope.row.expiredDate ? 'danger' : 'primary'">{{
                scope.row.expiredDate || '無時效'
              }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" label="簽署時間" width="130">
            <template slot-scope="scope">
              <div v-show="!scope.row.signedDate">-</div>
              <el-tag type="info" v-show="!!scope.row.signedDate">{{
                scope.row.signedDate
              }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" label="簽署狀態" width="130">
            <template slot-scope="scope">
              <a
                :href="scope.row.fileInfo.url"
                target="_blank"
                v-if="scope.row.signatureStatus === 1"
              >
                <el-button size="mini" type="success">
                  {{ scope.row.signatureStatusDesc }}
                  <i class="el-icon-download"></i>
                </el-button>
              </a>
              <el-button
                size="mini"
                type="primary"
                @click="handleClipboard(scope.row.contractLink, $event)"
                v-else-if="scope.row.signatureStatus === 2"
              >
                {{ scope.row.signatureStatusDesc }}
                <i class="el-icon-copy-document"></i>
              </el-button>
              <el-tag effect="plain" v-else type="info">
                {{ scope.row.signatureStatusDesc }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column align="center" label="操作" width="80">
            <template slot-scope="scope">
              <div>
                <!-- <el-button size="mini" plain icon="el-icon-copy-document" circle
                                    @click="handleClipboard(scope.row.contractLink, $event)">
                                </el-button> -->
                <el-button
                  size="mini"
                  type="danger"
                  @click="handleDeleteSignContract(scope.row.signatureId)"
                  >刪除</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogDetailVisible = false">關 閉</el-button>
      </div>
    </el-dialog>
    <el-form :inline="true" class="search-form" @submit.native.prevent>
      <el-form-item label="查詢">
        <el-input
          v-model="listQuery.qry"
          @keyup.enter.native="getList"
          placeholder="請輸入合約檔名"
        />
      </el-form-item>

      <el-form-item label="簽署狀態">
        <el-select v-model="listQuery.status">
          <el-option
            v-for="item in [
              { key: null, val: '全部' },
              { key: 1, val: '已簽署' },
              { key: 2, val: '未簽署' },
              { key: 3, val: '已結束' },
            ]"
            :key="item.key"
            :label="item.val"
            :value="item.key"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="getList"
          icon="el-icon-search"
          circle
          style="margin-left: 5px"
          :disabled="listLoading"
        ></el-button>
        <addContractDialog
          :loading="listLoading"
          @on-refresh="refresh()"
          style="display: inline-block"
        />
        <el-button
          style="cursor: pointer"
          type="success"
          :loading="listLoading"
          circle
          icon="el-icon-refresh-left"
          @click="refresh()"
        ></el-button>
      </el-form-item>
    </el-form>

    <div style="position: relative; height: 80%">
      <el-table
        ref="contractUploadTable"
        size="mini"
        :data="list"
        v-loading="listLoading"
        border
        style="width: 100%"
        height="100%"
      >
        <el-table-column align="center" label="項次" width="60">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column label="合約檔名" width="200" align="center">
          <template slot-scope="scope">
            <a :href="scope.row.fileInfo.originalUrl" target="_blank" style="color: #1890ff">
              {{ scope.row.name }}
              <i class="el-icon-download"></i>
            </a>
          </template>
        </el-table-column>

        <el-table-column align="center" label="建立時間" prop="buildDate" width="130">
        </el-table-column>

        <el-table-column align="center" label="連結時效性" width="130">
          <template slot-scope="scope">
            <el-tag effect="plain" :type="scope.row.type == 2 ? 'primary' : 'danger'"
              >{{ scope.row.typeDesc }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" label="簽署檔" width="150">
          <template slot-scope="{ row }">
            <el-tag
              @click="handleDetailDialog(row)"
              style="min-width: 60px; font-size: 20px; font-weight: bold; cursor: pointer"
              type="success"
              >{{ row.contractSignatures ? row.contractSignatures.length : 0 }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" label="產生簽署檔" width="130">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="success"
              @click="
                handleGenerateContractDialog(
                  scope.row.id,
                  scope.row.name,
                  scope.row.fileInfo.originalUrl
                )
              "
              >產生簽署檔</el-button
            >
          </template>
        </el-table-column>
        <el-table-column align="center" label="刪除" width="130">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              @click="handleDeleteContract(scope.row.id, scope.row.name)"
              >刪除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination
      v-show="total > 0"
      layout="prev, pager, next"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList"
    />
  </div>
</template>

<script>
import addContractDialog from '@/views/ita/agency/outSideContract/addContractDialog.vue'
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import {
  getSideContracts,
  generateSideContract,
  deleteSideContract,
  deleteSideSignContract,
} from '@/api/agency'
import clipboard from '@/utils/clipboard'

export default {
  name: 'ContractUploadList',
  components: {
    Pagination,
    addContractDialog,
  },
  data() {
    const agencyCode = this.$store.getters.userInfo.agencyCode
    return {
      dialogTopMargin: '20vh',
      formLabelWidth: '120px',
      form: {},
      dialogLoading: false,
      dialogVisible: false,
      dialogDetailVisible: false,
      listLoading: false,
      listQuery: {
        qry: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-BuildDate',
        agencyCode: agencyCode,
      },
      total: 0,
      list: [],
      generateParams: {
        id: '',
        fileName: '',
        fileLink: '',
        generateCount: 1,
      },
      generateContracts: [],
      detail: {
        title: '',
        id: null,
        data: [],
      },
    }
  },
  async created() {
    await this.getList()
  },
  methods: {
    async refresh() {
      const agencyCode = this.$store.getters.userInfo.agencyCode
      this.listQuery = {
        qry: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-BuildDate',
        agencyCode: agencyCode,
      }
      await this.getList()
    },

    async getList() {
      this.listLoading = true
      getSideContracts(this.listQuery)
        .then(resp => {
          this.list = resp.data.data
          this.total = resp.data.total
          if (this.dialogDetailVisible) {
            const detail = this.list.find(item => item.id == this.detail.id)
            this.detail.data = []
            this.detail.data =
              !!detail.contractSignatures && detail.contractSignatures.length > 0
                ? detail.contractSignatures
                : []
            this.$nextTick(() => {
              this.$refs['detailTable'].doLayout()
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.listLoading = false
        })
    },

    handleDetailDialog(row) {
      console.log(row)
      this.detail.title = row.name
      this.detail.id = row.id
      this.detail.data = row.contractSignatures
      this.dialogDetailVisible = true
    },
    handleClipboard(text, event) {
      clipboard(text, event)
    },
    handleGenerateContractDialogClose() {
      this.generateParams = {
        id: '',
        fileName: '',
        fileLink: '',
        generateCount: 1,
      }
      if (this.generateContracts && this.generateContracts.length > 0) {
        this.generateContracts = []
        this.getList()
      }
    },
    async handleDeleteContract(id, file) {
      if (!confirm(`確定要刪除「${file}」?`)) return
      this.listLoading = true
      const params = {
        id: id,
      }
      deleteSideContract(params)
        .then(resp => {
          if (resp.success) {
            this.$message({
              message: '刪除合約成功',
              type: 'success',
            })
            this.getList()
          }
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    async handleDeleteSignContract(id) {
      if (!confirm(`確定要刪除簽署檔連結?`)) return
      this.listLoading = true
      const params = {
        signId: id,
      }
      deleteSideSignContract(params)
        .then(resp => {
          if (resp.success) {
            this.$message({
              message: '刪除合約成功',
              type: 'success',
            })
            this.getList()
          }
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    handleGenerateContractDialog(id, fileName, fileLink) {
      this.generateParams.id = id
      this.generateParams.fileName = fileName
      this.generateParams.fileLink = fileLink
      this.dialogVisible = true
    },
    async handleGenerateContract() {
      const { id, generateCount } = this.generateParams
      const params = { id, generateCount }
      this.generateContracts = []
      this.dialogLoading = true
      generateSideContract(params)
        .then(resp => {
          if (resp.success) {
            this.generateContracts = resp.data
            // this.dialogVisible = false
          }
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.dialogLoading = false
        })
    },
  },
}
</script>

<style scoped>
.search-form {
  display: flex;
  align-items: center;
  width: 100%;
}
</style>

<style>
.full-height {
  position: relative;
  height: 100%;
}

.el-dialog__body {
  padding-top: 0px;
}

.el-table .success-row {
  background: #f0f9eb;
}

.el-table__expanded-cell,
.el-table__expanded-cell:hover {
  background-color: cornsilk !important;
}

.el-table__expand-icon {
  display: none;
}
</style>
